import { getSolidShapes } from '@shared/helpers/design/cutout.helpers';
import { isPointInsideStoreySolidOccupancy } from '@shared/helpers/design/shape.helpers';
import type { Storey } from '@shared/models/design/storey.model';
import type { Point2D } from '@shared/models/geometry.model';

/**
 * Resolve whether the first draft click should open a cutout draft.
 *
 * Alt / Draw imply cutout only on occupied floor plate (outer ring or a
 * courtyard-house solid). Empty cutout holes and points outside every solid
 * start a solid draft instead (DEV-3020 / DEV-3843), so Finalize is not
 * rejected as a nested void.
 */
export const resolveNewDraftCutoutMode = (options: {
  cutoutIntent: boolean;
  storey: Storey | undefined;
  point: Point2D;
}): boolean => {
  if (!options.cutoutIntent) return false;
  const { storey, point } = options;
  if (!storey || !getSolidShapes(storey).length) return true;
  // Occupancy excludes empty holes but keeps courtyard-house footprints.
  return isPointInsideStoreySolidOccupancy(point, storey);
};
